import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { ISensitiveCities } from 'src/models/sensitive-cities.model';
import style from './sensitive-cities-list.module.scss';
import SensitiveCitiesAdd from '../sensitive-cities-add/sensitive-cities-add.component';
import SensitiveCitiesEdit from '../sensitive-cities-edit/sensitive-cities-edit.component';
import SensitiveCityDelete from '../sensitive-cities-delete/sensitive-cities-delete.component';

type IProp = {
  data: ISensitiveCities[];
  loading: boolean;
};

const SensitiveCitiesView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<ISensitiveCities>[] = [
    {
      title: Lang.LBL_SENSITIVE_CITY,
      index: 'sensitiveCity',
      width: '35%',
    },
    {
      title: Lang.LBL_SENSITIVE_CITY_PAM_LEAD,
      index: 'pamLead',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <SensitiveCityDelete data={value} />
          <SensitiveCitiesEdit data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[0].render) {
      customColumns[0].render(true, {} as ISensitiveCities, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_SENSITIVE_CITIES} />
        <SensitiveCitiesAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default SensitiveCitiesView;
